import React from 'react';
import SampleKitBlock from '../components/blocks/SampleKitBlock';
import Seo from '../components/Seo';
import { useLang } from '../LangContext';

/**
 * SampleKitPage — standalone /gratis-stalen page.
 * Reuses the SampleKitBlock with a top hero band and full-page rhythm.
 */
export default function SampleKitPage() {
  const { lang, c } = useLang();
  return (
    <article data-testid="sample-kit-page" className="relative bg-[#FAF8F2]">
      <Seo
        title={c.sampleKit.title}
        description={c.sampleKit.body}
        path="/gratis-stalen"
        lang={lang}
      />
      <div className="pt-24 sm:pt-32" />
      <SampleKitBlock {...c.sampleKit} lang={lang} rhythm="grand" />
    </article>
  );
}
